"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LapSocratic_exports = {};
__export(LapSocratic_exports, {
  default: () => LapSocratic_default
});
module.exports = __toCommonJS(LapSocratic_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.3008 9.42969L14.4453 11.1875C14.4193 11.2005 14.3867 11.2135 14.3477 11.2266C14.3216 11.2396 14.2891 11.2461 14.25 11.2461C14.224 11.2461 14.1914 11.2396 14.1523 11.2266C14.1133 11.2135 14.0807 11.194 14.0547 11.168C14.0026 11.1159 13.9766 11.0508 13.9766 10.9727C13.9766 10.8945 14.0091 10.8294 14.0742 10.7773L15.9297 9.03906C15.9818 8.98698 16.0469 8.96094 16.125 8.96094C16.2031 8.96094 16.2682 8.98698 16.3203 9.03906C16.3724 9.09115 16.3984 9.15625 16.3984 9.23438C16.3984 9.3125 16.3659 9.3776 16.3008 9.42969ZM10.0703 15.6992L9.79688 15.4062L10.0117 14.6836L10.793 15.5234L10.0703 15.6992ZM17.043 8.29688C16.9128 8.15365 16.7435 8.08203 16.5352 8.08203C16.3268 8.06901 16.151 8.13411 16.0078 8.27734L9.83594 13.9609L9.50391 15.0938L9.42578 15.3672L9.36719 15.543L9.34766 15.6211H6.02734V16.2266H9.38672V16.207C9.39974 16.2201 9.41276 16.2266 9.42578 16.2266C9.4388 16.2266 9.44531 16.2266 9.44531 16.2266L11.4961 15.7188L17.668 10.0156C17.8112 9.88542 17.8828 9.72266 17.8828 9.52734C17.8958 9.31901 17.8307 9.14323 17.6875 9L17.043 8.29688ZM6.02734 14.9766H8.58594V14.2344H6.02734V14.9766ZM6.02734 13.6875H9.23047V12.9453H6.02734V13.6875ZM6.02734 12.3789H10.5V11.6562H6.02734V12.3789ZM6.02734 11.0898H11.7695V10.3672H6.02734V11.0898ZM6.02734 9.80078H12.9023V9.07812H6.02734V9.80078ZM6.02734 8.51172H12.9023V7.76953H6.02734V8.51172ZM18.0391 10.4258L14.7578 13.4727V16.8516C14.7578 17.0599 14.6862 17.2357 14.543 17.3789C14.3997 17.5221 14.224 17.5938 14.0156 17.5938H4.77734C4.56901 17.5938 4.39323 17.5221 4.25 17.3789C4.10677 17.2357 4.03516 17.0599 4.03516 16.8516V7.08594H6.75V4.37109H14.0156C14.224 4.37109 14.3997 4.44271 14.543 4.58594C14.6862 4.72917 14.7578 4.89844 14.7578 5.09375V8.6875L15.6367 7.86719C15.7539 7.75 15.8841 7.66536 16.0273 7.61328C16.1836 7.54818 16.3464 7.51562 16.5156 7.51562C16.6849 7.51562 16.8542 7.55469 17.0234 7.63281C17.1927 7.69792 17.3359 7.79557 17.4531 7.92578L18.0977 8.62891C18.3451 8.8763 18.4622 9.18229 18.4492 9.54688C18.4362 9.89844 18.2995 10.1914 18.0391 10.4258ZM3.91797 6.28516L5.96875 4.23438C5.96875 4.22135 5.97526 4.22135 5.98828 4.23438C6.01432 4.23438 6.02734 4.2474 6.02734 4.27344V6.34375H3.9375C3.92448 6.34375 3.91146 6.33724 3.89844 6.32422C3.89844 6.3112 3.90495 6.29818 3.91797 6.28516ZM1.33984 19.4102H19.6602V1.08984H1.33984V19.4102Z",
      fill: "currentColor"
    }
  )
);
const SvgLapSocratic = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LapSocratic_default = SvgLapSocratic;
